import React from "react";
import {Alert, Box, TextField} from "@mui/material";
import {completude} from "../sistemaPagina";
import SecaoCard from "./SecaoCard";
import {CompletudeChip} from "./SistemaVisual";

// O fiscal ainda não tem API nem dado no banco: a seção aparece desligada, com o aviso (decisão de 18/10/2026).
// Sem ela, a falta de código de serviço não entra nas pendências.

export const FiscalSecao = ({sistema, pendencias}) => (
    <SecaoCard id="fiscal" titulo="Fiscal" chip={<CompletudeChip completude={completude('fiscal', {sistema, pendencias})} />}>
        <Alert severity="info" variant="outlined" sx={{mb: 2.5}}>
            <strong>Ainda sem API.</strong> O sistema não guarda o código de serviço, a NBS nem a descrição na nota. Os campos ficam desligados, e a falta do código de serviço não aparece nas pendências.
        </Alert>
        <Box sx={{display: 'grid', gap: 2.5, gridTemplateColumns: {xs: '1fr', md: '1fr 1fr'}}}>
            <TextField label="Código de serviço (LC 116)" disabled fullWidth helperText="A confirmar com a contabilidade." />
            <TextField label="NBS" disabled fullWidth helperText="Exigida na NFS-e nacional." />
            <Box sx={{gridColumn: {md: '1 / -1'}}}>
                <TextField label="Descrição na nota" disabled fullWidth multiline minRows={2} helperText="É o que o cliente lê na nota." />
            </Box>
        </Box>
    </SecaoCard>
);
